import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
    name: 'toJSDate',
    standalone: false
})
export class ToJSDatePipe implements PipeTransform {

  transform(value: DateTime | undefined): Date | undefined {
    return value?.toJSDate();
  }
}
